import { InDefCommonFlagType } from "../../util/general-code/enums/general-codes";
import { Option } from "../../util/option";

export const PAGE_MODE = {
  GOD_MODE: "god",
  INPUT_MODE: "input",
  REF_MODE: "reference",
  REQ_APPROVAL_MODE: "request-approval",
  REVIEW_MODE: "review",
  STG_DPLYMNT_MODE: "stg-deployment",
  PRD_DPLYMNT_MODE: "prd-deployment",
};

export const PAGE_TYPE = {
  ACTIVE_PJ_TYPE: "project",
  PRD_PJ_TYPE: "prd",
  STG_PJ_TYPE: "stg",
};

export const INIT_ROW_IDX = -1;

export const PJT_STS = {
  OPEN: "1",
  CLOSED: "2",
};
export const CD_TYPES = [
  "in_def_common_flag_type",
  "security_contents_type",
  "send_datalake_type",
  "reference_mode_type",
  "file_extension_type",
  "review_action_type",
  "interface_requirement_type",
  "edh_notification_type",
  "edh_prtcl_type",
  "ptnr_type",
  "chn_type_type",
  "file_type_type",
  "if_cycle_type",
  "snapshot_incremental_delta_type",
  "data_scope_type",
  "encription_type",
  "security_information_level_type",
  "tckt_sts_type_prj_prgrs",
  "retention_period_days_type",
  "edi_polling_adaptor_type",
  "interrupt_type",
];

export const VRF_SUCCESS_COLOR = "#1b8221";
export const VRF_PRIMARY_COLOR = "#38468c";

// ticket status define master
export const DSGN_W_FLW_STS_DESIGNING = "Designing";
export const DSGN_W_FLW_STS_DESIGN_REVIEW = "Reviewing";
export const DSGN_W_FLW_STS_CANCELLED = "Cancelled";
export const DPlYMNT_W_FLW_STS_DEPLOYED = "Deployed";
export const DPlYMNT_W_FLW_STS_CANCELLED = "Cancelled";

export const createMessageList = (mode: string, isPendingDisplay: boolean) => {
  switch (mode) {
    case PAGE_MODE.REQ_APPROVAL_MODE:
      return [
        {
          message:
            "In case of Cross Domain IF, Src and Dst can request review separately.",
        },
        {
          message:
            "In case of DIP turnaround, Src and Dst are always requested as a set for review.",
        },
      ];
    case PAGE_MODE.STG_DPLYMNT_MODE && !isPendingDisplay:
      return [
        {
          message:
            "In case of Cross Domain IF, Src and Dst can create deployment request separately.",
        },
        {
          message:
            "In case of DIP turnaround, Src and Dst are always requested as a set for deployment.",
        },
      ];
    case PAGE_MODE.STG_DPLYMNT_MODE && isPendingDisplay:
      return [
        {
          message:
            'There is an IF definition that is transferred only on the Src side of the Cross Domain IF, and the Outbound Interrupt Type is set to "Pending" (Optional).',
        },
        {
          message:
            "When the Outbound Pending Flag is set to On, IF information is pending before it is linked to the outbound system by the Transceiver.",
        },
      ];
    case PAGE_MODE.PRD_DPLYMNT_MODE && !isPendingDisplay:
      return [
        {
          message:
            "Both Cross Domain and DIP crossing must be transferred to production as a combination of Src and Dst.",
        },
      ];
    case PAGE_MODE.PRD_DPLYMNT_MODE && isPendingDisplay:
      return [
        {
          message:
            "When the Outbound Pending Flag is set to On, IF information is pending before it is linked to the outbound system by the Transceiver.",
        },
      ];
  }
};

export const andConditionList: Option[] = [
  { label: "AND", value: InDefCommonFlagType.YES },
  { label: "OR", value: InDefCommonFlagType.NO },
];

export const shpCsvHeader = [
  "Interface ID",
  "Interface Name",
  "インターフェース名",
  "Component ID(From)",
  "Component ID(To)",
  "Inbound ID",
  "Outbound ID",
  "EDI Inbound File Type Code",
  "EDI Inbound File Type",
  "EDI Inbound Partner Init Flg",
  "EDI Inbound Partner Code",
  "EDI Inbound Partner Type Code",
  "EDI Inbound Partner Type Name",
  "EDI Inbound Partner Name",
  "EDI Inbound Partner Business Unit Code",
  "EDI Inbound Partner Country Code",
  "EDI Outbound File Type Code",
  "EDI Outbound File Type",
  "EDI Outbound Partner Code",
  "EDI Outbound Partner Type Code",
  "EDI Outbound Partner Type Name",
  "EDI Outbound Partner Name",
  "EDI Outbound Partner Business Unit Code",
  "EDI Outbound Partner Country Code",
];

export const REVIEW_DIFF_TARGET = {
  NONE: "NONE",
  PREV_REVIEW: "PREV_REVIEW",
  LATEST_STG: "LATEST_STG",
  LATEST_PRD: "LATEST_PRD",
  PJ_START_STG: "PJ_START_STG",
  PJ_START_PRD: "PJ_START_PRD",
} as const;
